import {Component, Input, OnInit} from 'ng-metadata/core';
import {ICDCollectionObject} from "../collectionDiscovery.service";

@Component({
    selector: 'prm-collection-navigation-breadcrumbs',
    templateUrl: 'components/collectionDiscovery/collectionNavigationBreadcrumbs/collection-navigation-breadcrumbs.html',
})

export class PrmCollectionNavigationBreadcrumbs implements OnInit{
    @Input() path: [ICDCollectionObject];
    @Input() institution: string;
    @Input() isAlmaDisplay: Boolean;

    constructor() {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/collectionDiscovery/collectionNavigationBreadcrumbs/collectionNavigationBreadcrumbs.directive.ts